module.exports = __webpack_public_path__ + "img/barrel-creek-2024-sauv-blanc.5b77cb4c.png";